module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/a-function.js